import React, { forwardRef } from 'react';
import './Button.less';

/**
 * Polymorphic button. Renders a native <button> by default; pass
 * `as={Link}` or `as="a"` to render as an anchor. The `type="button"`
 * default is only applied for real button elements.
 */
const Button = forwardRef(function Button(
  {
    as: Tag = 'button',
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    busy = false,
    leadingIcon,
    trailingIcon,
    type,
    disabled,
    className = '',
    ...rest
  },
  ref,
) {
  const isButton = Tag === 'button';
  return (
    <Tag
      ref={ref}
      type={isButton ? (type || 'button') : undefined}
      disabled={isButton ? (busy || disabled) : undefined}
      aria-busy={busy || undefined}
      aria-disabled={!isButton && (busy || disabled) ? 'true' : undefined}
      className={
        `gc-btn gc-btn-${variant} gc-btn-size-${size}` +
        (fullWidth ? ' is-full' : '') +
        (busy ? ' is-busy' : '') +
        ((busy || disabled) && !isButton ? ' is-disabled' : '') +
        (className ? ` ${className}` : '')
      }
      {...rest}
    >
      {busy && <span className="gc-btn-spinner" aria-hidden="true" />}
      {!busy && leadingIcon && <span className="gc-btn-icon" aria-hidden="true">{leadingIcon}</span>}
      <span className="gc-btn-label">{children}</span>
      {!busy && trailingIcon && <span className="gc-btn-icon" aria-hidden="true">{trailingIcon}</span>}
    </Tag>
  );
});

export default Button;
